import React from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";

const MobileMenu = ({ closeMenu, menuOpen }) => {
  const location = useLocation();
  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Wrapper>
      <div className={`th-menu-wrapper ${menuOpen ? "th-body-visible" : ""}`}>
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle" onClick={closeMenu}>
            <i className="fal fa-times"></i>
          </button>

          <div className="mobile-logo">
            <Link to="/" onClick={closeMenu}>
              <img
                src="/assets/image/Logo.png"
                alt="logo img"
                style={{ width: "170px", height: "66px" }}
              />
            </Link>
          </div>

          <div className="th-mobile-menu">
            <ul>
              <li>
                <Link
                  to="/"
                  className={isActive("/") ? "active" : ""}
                  onClick={closeMenu}
                >
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/about"
                  className={isActive("/about") ? "active" : ""}
                  onClick={closeMenu}
                >
                  About
                </Link>
              </li>

              <li>
                <Link
                  to="/service"
                  className={isActive("/service") ? "active" : ""}
                  onClick={closeMenu}
                >
                  Service
                </Link>
              </li>

              <li>
                <Link
                  to="/project"
                  className={isActive("/project") ? "active" : ""}
                  onClick={closeMenu}
                >
                  Project
                </Link>
              </li>

              <li>
                <Link
                  to="/gallery"
                  className={isActive("/gallery") ? "active" : ""}
                  onClick={closeMenu}
                >
                  Gallery
                </Link>
              </li>

              <li>
                <Link
                  to="/blog"
                  className={isActive("/blog") ? "active" : ""}
                  onClick={closeMenu}
                >
                  Blog
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  className={isActive("/contact") ? "active" : ""}
                  onClick={closeMenu}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .th-mobile-menu ul {
    list-style: none;
  }

  .th-mobile-menu ul li {
    margin-bottom: 15px;
  }

  .th-mobile-menu ul li a {
    font-size: 15px;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: color 0.3s ease;
  }

  .th-mobile-menu ul li a.active {
    color: #ff5e14 !important;
  }
`;

export default MobileMenu;
